import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './Welcome.css'
import logo from 'assets/logo-transparent.png'
import blankLogo from 'assets/logo-transparent-blank.png'
import Icon from '../Icon'

export default class Welcome extends Component {
  state = {
    page: this.props.shareOnly ? 2 : 0
  }
  nextPage = () => {
    this.setState({
      page: this.state.page + 1
    })
  }
  prevPage = () => {
    this.setState({
      page: this.state.page - 1
    })
  }
  render () {
    const { canSearch, canShare } = this.props
    const { page } = this.state

    return (
      <div className={classNames.wrapper}>
        {page === 0 &&
          <div className={classNames.window}>
            <img src={logo} className={classNames.logo} />
            <h1 className={classNames.heading}>
              Welcome to Blayzr!
            </h1>
            <div className={classNames.text}>
              <p>
                A living catalogue of favourite moments and best memories.
              </p>
              <p>
                Crafted with love just for you!
              </p>
            </div>
            {canSearch &&
              <button onClick={this.nextPage} className={classNames.button}>
                Next
              </button>
            }
            {!canSearch &&
              <Link to='/albums' onClick={this.props.onClose} className={classNames.button}>
                Happy Hunting!
              </Link>
            }
          </div>
        }
        {page === 1 &&
          <div className={classNames.window}>
            <div className={classNames.logoOverlay}>
              <img src={blankLogo} className={classNames.logo} />
              <Icon icon='search' size={36} style={{ marginTop: '-3px', marginLeft: '-1px' }} />
            </div>
            <h1 className={classNames.heading}>
              Make it yours
            </h1>
            <div className={classNames.text}>
              <p className={classNames.biggerMargin}>
                Across thousands of images, easily find People, Places, Events, Actions, Objects <br />…or anything else you can think of!
              </p>
              <p>
                Search for images and save albums
              </p>
              <p>
                Play slideshows
              </p>
              <p>
                Create your own collections and customise your experience
              </p>
            </div>
            <button onClick={this.prevPage} className={classNames.backButton}>
              <Icon icon='chevron-left' size={30} />
            </button>
            {canShare &&
              <button onClick={this.nextPage} className={classNames.button}>
                Next
              </button>
            }
            {!canShare &&
              <Link to='/albums' onClick={this.props.onClose} className={classNames.button}>
                Happy Hunting!
              </Link>
            }
          </div>
        }
        {page === 2 &&
          <div className={classNames.window}>
            <div className={classNames.logoOverlay}>
              <img src={blankLogo} className={classNames.logo} />
              <Icon icon='heart' size={36} />
            </div>
            <h1 className={classNames.heading}>
              Sharing and Caring
            </h1>
            <div className={classNames.text}>
              <p>
                This is a private shared trove for everyone to enjoy and also respect
              </p>
              <p>
                Share your favourites with me!
              </p>
              <p>
                Please remember to be wise sharing online generally and ask for permission from family before posting on social media etc.
              </p>
              <p>
                Keep your password secure and do not share it with others.
              </p>
              <p>
                Let me know asap if there is an issue.
              </p>
              <p>
                Build it with me – this will always be a work in progress – if you see something that doesn't make sense, let me know; or if you spot someone who is missing, please flag the image with specific info so we can fix it for everyone.
              </p>
            </div>
            {!this.props.shareOnly &&
              <button onClick={this.prevPage} className={classNames.backButton}>
                <Icon icon='chevron-left' size={30} />
              </button>
            }
            <Link to='/albums' onClick={this.props.onClose} className={classNames.button}>
              Happy Hunting!
            </Link>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/home/Welcome.js